var values =  {
    MEMORANDUM_NAME : "Approval Memorandum",
    "CAMORFAM": "FAM"
}

export default values;

// MEMORANDUM_NAME : "Credit Appraisal Memorandum",
 //   "CAMORFAM": "CAM" (FAM)

 /*
 var values =  {
    MEMORANDUM_NAME : "Facility Appraisal Memorandum (FAM)",
    "CAMORFAM": "FAM"
}

 */